module.exports = __webpack_public_path__ + "img/security.6c793a63.png";